import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RecuperarContraseniaPage } from './recuperar-contrasenia';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

@NgModule({
  declarations: [
    RecuperarContraseniaPage,
  ],
  imports: [
    IonicPageModule.forChild(RecuperarContraseniaPage),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
  ],
})
export class RecuperarContraseniaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/recuperar-contrasenia/recuperar-contrasenia.module.ts